export const ACTIVITY_REPORTS = "/api/folder-groups/:param/activity-reports"
export const ACTIVITY_REPORT = "/api/folder-groups/:param/activity-reports/:activityReportParam"

export const GENERATE_GLOBAL_RESULT = "/api/folder-groups/:param/activity-reports/generate"

export const ACTIVITY_REPORT_DEACTIVATE = "/api/folder-groups/:param/activity-reports/:activityReportParam/deactivate"
export const ACTIVITY_REPORT_ACTIVATE = "/api/folder-groups/:param/activity-reports/:activityReportParam/activate"
